export default {"src":"/_next/static/media/PackageIconRed.6b4e6abb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};